var React = require('react');

function LogoTextSmallInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.46307 4.54559H6.86571C6.86571 8.48892 10.0514 11.6719 13.9967 11.6719H24.2401V15.7232H6.61255C6.9745 19.5216 10.1602 22.4878 14.0692 22.4878C17.3993 22.4878 20.1506 20.4618 21.2364 17.2063H24.2408V25.454H3.46307V4.54559Z","fill":"currentColor"}));
}

LogoTextSmallInline.defaultProps = {"width":"27.7037","height":"30.8292","viewBox":"0 0 27.7037 30.8292","fill":"none"};

module.exports = LogoTextSmallInline;

LogoTextSmallInline.default = LogoTextSmallInline;
